<bit-side-nav [variant]="variant()">
  <!-- ngProjectAs so the re-projected logo reaches the side nav's logo slot instead of falling
  through to its wildcard slot, which v2 renders in the nav body rather than the header row. -->
  <ng-content select="bit-nav-logo" ngProjectAs="bit-nav-logo"></ng-content>
  <ng-content></ng-content>

  <ng-container slot="product-switcher">
    <navigation-product-switcher [variant]="variant()"></navigation-product-switcher>
  </ng-container>

  <ng-container slot="account">
    @if (vfo1FoundationEnabled()) {
      <app-account-menu [expanded]="sideNavService.open()"></app-account-menu>
    }
  </ng-container>

  <ng-container slot="callout">
    @if (vfo1FoundationEnabled()) {
      <vault-tour-callout></vault-tour-callout>
    }
    @if (
      !(vfo1FoundationEnabled() && tourCalloutClaimsSlot()) &&
      (shouldShowPremiumUpgradeButton$ | async)
    ) {
      <app-upgrade-callout></app-upgrade-callout>
    }
  </ng-container>
</bit-side-nav>
